import { z } from "zod";
export const ServiceTypeSchema = z.object({
    id: z.guid(),
    name: z.string(),
    isContact: z.boolean(),
});
export const ServiceTypesResponseSchema = z.object({
    serviceTypes: z.array(ServiceTypeSchema),
});
// A service type as something else refers to it — its id, display name, and
// whether ICIS still had it active at the last import. Distinct from
// ServiceTypeSchema above, which is the classification screen's own shape:
// `isContact` is that screen's business and means nothing to anyone else.
export const ServiceTypeSummarySchema = z.object({
    id: z.guid(),
    name: z.string(),
    active: z.boolean(),
});
// PATCH body — the admin sets a service type's contact classification.
export const ClassifyServiceTypeSchema = z.object({
    isContact: z.boolean(),
});
